import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Callout } from '@node-space/ui-components'
import { useOnceOffExportContext } from 'hooks/context/useOnceOffExportContext'
import { ReportTypes } from 'types/transactionsExport'
import { getOnceOffExportErrorMessage } from 'utils/export/exportErrorMessages'
import { BalanceDateField } from './components/BalanceDateField'
import { DateRangeSelector } from './components/DateRangeSelector'
import { ExportFormatSelector } from './components/ExportFormatSelector'
import { ReportTypeSelector } from './components/ReportTypeSelector'

interface OnceOffTransactionExportFormProps {
  allowBalanceReport?: boolean
  showFormatSelector?: boolean
}

export const OnceOffTransactionExportForm = ({
  allowBalanceReport = true,
  showFormatSelector = true,
}: OnceOffTransactionExportFormProps) => {
  const { t } = useTranslation()

  const { formValues, sendTransactionsReportError, isErrorSendTransactionsReport } =
    useOnceOffExportContext()

  const isTransactionReport = formValues?.reportType === ReportTypes.TRANSACTION
  const isBalanceReport = formValues?.reportType === ReportTypes.BALANCE

  const errorMessage = getOnceOffExportErrorMessage(sendTransactionsReportError, t)

  return (
    <Box tag="form">
      {allowBalanceReport && (
        <Box paddingB={16}>
          <ReportTypeSelector />
        </Box>
      )}
      {isTransactionReport && <DateRangeSelector />}
      {isBalanceReport && <BalanceDateField />}
      {isTransactionReport && showFormatSelector && (
        <Box paddingT={16}>
          <ExportFormatSelector />
        </Box>
      )}
      {isErrorSendTransactionsReport && (
        <Box paddingL={12} paddingB={12} paddingT={16}>
          <Callout variant="error">{errorMessage}</Callout>
        </Box>
      )}
    </Box>
  )
}
